import { useScrollReveal } from '../../hooks/useScrollReveal';

const STEPS = [
  {
    num: '01',
    title: 'Create Your Province',
    desc: 'Choose your race and personality. Each combination unlocks unique units, spells, and strategic advantages.',
    icon: (
      <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="#a89889" strokeWidth="2">
        <circle cx="12" cy="7" r="4" />
        <path d="M5.5 21a6.5 6.5 0 0 1 13 0" />
      </svg>
    ),
  },
  {
    num: '02',
    title: 'Build & Grow',
    desc: 'Construct farms, barracks, towers, and guilds. Balance your economy against military readiness — resources are finite.',
    icon: (
      <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="#a89889" strokeWidth="2">
        <rect x="3" y="3" width="7" height="7" />
        <rect x="14" y="3" width="7" height="7" />
        <rect x="3" y="14" width="7" height="7" />
        <rect x="14" y="14" width="7" height="7" />
      </svg>
    ),
  },
  {
    num: '03',
    title: 'Gather Intelligence',
    desc: 'Send thieves, cast divination spells, and survey your enemies. Strike only when you know their weaknesses.',
    icon: (
      <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="#a89889" strokeWidth="2">
        <circle cx="11" cy="11" r="8" />
        <path d="M21 21l-4.35-4.35" />
      </svg>
    ),
  },
  {
    num: '04',
    title: 'Wage War',
    desc: 'Launch calculated attacks, coordinate kingdom-wide operations, and dominate the age through strategy — not luck.',
    icon: (
      <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="#a89889" strokeWidth="2">
        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
      </svg>
    ),
  },
];

export function HowItWorks() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section id="how" className="px-6 md:px-12 py-24 max-w-[1200px] mx-auto" ref={ref}>
      <div
        style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
          transition: 'opacity 0.6s ease, transform 0.6s ease',
        }}
      >
        <div
          className="mb-3 uppercase tracking-[0.15em]"
          style={{ fontFamily: "'Cinzel', serif", fontSize: 11, fontWeight: 600, color: '#a08030' }}
        >
          How It Works
        </div>
        <h2
          className="mb-4"
          style={{ fontFamily: "'Cinzel', serif", fontSize: 36, fontWeight: 700, color: '#f0e8dc', lineHeight: 1.2 }}
        >
          Four Steps to Power
        </h2>
        <p className="mb-12 max-w-[640px]" style={{ color: '#e0d5c8', fontSize: 18 }}>
          From your first settlement to commanding a feared province — the path is yours to forge.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
          {STEPS.map((step) => (
            <div
              key={step.num}
              className="rounded-lg p-8 transition-all duration-300 hover:-translate-y-0.5 hover:border-game-650"
              style={{
                background: '#1c1916',
                border: '1px solid #24201b',
              }}
            >
              <div
                style={{
                  fontFamily: "'JetBrains Mono', monospace",
                  fontSize: 48,
                  fontWeight: 600,
                  color: '#2e2924',
                  lineHeight: 1,
                  marginBottom: 16,
                }}
              >
                {step.num}
              </div>
              <div
                className="flex items-center justify-center rounded-lg mb-4"
                style={{
                  width: 48,
                  height: 48,
                  background: '#0a0908',
                  border: '1px solid #2e2924',
                }}
              >
                {step.icon}
              </div>
              <div
                className="mb-2"
                style={{ fontFamily: "'Cinzel', serif", fontSize: 16, fontWeight: 600, color: '#f0e8dc' }}
              >
                {step.title}
              </div>
              <div style={{ color: '#e0d5c8', fontSize: 15, lineHeight: 1.6 }}>{step.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
